import React, { useState, useEffect } from "react";
import "./ComputingBenefit.css";

const cards = [
  {
    head: "Generative AI for Customer Experience",
    subhead:
      "We build secure GenAI solutions using encryption, access controls, and monitoring to protect sensitive data and ensure enterprise-grade integrity.",
  },
  {
    head: "Generative AI for Operational Efficiency",
    subhead:
      "We prioritize fairness, transparency, and privacy at every stage. Our models are responsibly designed and trained to mitigate bias, ensuring inclusive, trustworthy AI aligned with global compliance standards.",
  },
  {
    head: "Generative AI for Sales Acceleration",
    subhead:
      "We design AI systems that are easy to use and easy to trust. Clear, thoughtful interfaces enable users to interact effortlessly and realize value without added complexity.",
  },
  {
    head: "Generative AI for Enterprise",
    subhead:
      "We apply rigorous quality assurance across development and training, including continuous testing, validation, and monitoring to ensure accuracy, relevance, and consistent performance.",
  },
  {
    head: "Generative AI for Enterprise",
    subhead:
      "We apply rigorous quality assurance across development and training, including continuous testing, validation, and monitoring to ensure accuracy, relevance, and consistent performance.",
  },
  {
    head: "Generative AI for Enterprise",
    subhead:
      "We apply rigorous quality assurance across development and training, including continuous testing, validation, and monitoring to ensure accuracy, relevance, and consistent performance.",
  },
];

const ChevronLeft = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
);

const ChevronRight = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

export default function ComputingBenefits() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsPerSlide, setCardsPerSlide] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setCardsPerSlide(4);
      } else if (window.innerWidth >= 768) {
        setCardsPerSlide(2);
      } else {
        setCardsPerSlide(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalSlides = Math.ceil(cards.length / cardsPerSlide);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  return (
    <div id="computing-benefit" className="outsourcemainclass">
      <div className="top">
        <h2 className="heading">
          Values We Deliver with DevOps and Automation Services
        </h2>
        <p className="subheading">
          Driving faster releases, higher reliability, and continuous innovation
          through intelligent DevOps automation.{" "}
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => {
          return (
            <div className="card" key={card.head}>
              <div className="content">
                <h3>{card.head}</h3>
                <span>{card.subhead}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Carousel for mobile */}
      <div className="carousel-container">
        <div className="carousel-inner">
          <button
            className="carousel-btn prev"
            onClick={prevSlide}
            aria-label="Previous slide"
          >
            <ChevronLeft />
          </button>

          <div className="carousel-wrapper">
            <div
              className="carousel-track"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div className="carousel-slide" key={slideIndex}>
                  <div className="carousel-slide-content">
                    {cards
                      .slice(
                        slideIndex * cardsPerSlide,
                        (slideIndex + 1) * cardsPerSlide
                      )
                      .map((card, cardIndex) => (
                        <div className="card" key={cardIndex}>
                          <div className="content">
                            <h3 style={{ color: card.color }}>{card.head}</h3>
                            <span>{card.subhead}</span>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            className="carousel-btn next"
            onClick={nextSlide}
            aria-label="Next slide"
          >
            <ChevronRight />
          </button>
        </div>

        <div className="carousel-dots">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
